// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","value":"InvestmentsTile_value__38faB","desc":"InvestmentsTile_desc__2JccW"};